import React, { useState } from 'react';
import { NavBar } from '../components/SubscriptionAppNavBar';
import { Card } from '../components/SubscriptionAppCard';
import { Badge } from '../components/SubscriptionAppBadge';
import { Button } from '../components/SubscriptionAppButton';
import { Settings, ExternalLink, Info, AlertTriangle, CheckCircle2 } from 'lucide-react';
export function IntegrationsPage() {
  const [isStripeModalOpen, setIsStripeModalOpen] = useState(false);
  const [modalStep, setModalStep] = useState<'connect' | 'success'>('connect');
  const [isStripeConnected, setIsStripeConnected] = useState(false);
  const [stripeTestMode, setStripeTestMode] = useState(false);
  const [stripeWarningTestMode, setStripeWarningTestMode] = useState(false);
  const openStripeModal = () => {
    setModalStep('connect');
    setIsStripeModalOpen(true);
  };
  const closeStripeModal = () => {
    setIsStripeModalOpen(false);
    setModalStep('connect');
  };
  const handleContinueToStripe = () => {
    setModalStep('success');
  };
  const handleDone = () => {
    setIsStripeConnected(true);
    closeStripeModal();
  };
  return <div className="bg-[#F1F5F9] min-h-full p-4 md:p-6" data-id="element-6241">
      {/* NavBar */}
      <div className="mb-4 md:mb-6" data-id="element-6242">
        <NavBar tabs={[]} title="Integrations" data-id="element-6243" />
      </div>

      {/* Page Subtitle */}
      <div className="mb-4 md:mb-6" data-id="element-6244">
        <p className="text-[13px] md:text-[14px] text-[#64748B]" data-id="element-6245">
          Connect WinePik with your favorite tools and services
        </p>
      </div>

      {/* Single Column Layout */}
      <div className="max-w-6xl space-y-6 md:space-y-8" data-id="element-6246">
        {/* Section 1: Active Integrations */}
        <div data-id="element-6247">
          <div className="mb-3 md:mb-4" data-id="element-6248">
            <h2 className="text-[18px] md:text-[20px] font-semibold text-[#0F172A] mb-1" data-id="element-6249">
              Active Integrations
            </h2>
            <p className="text-[13px] md:text-[14px] text-[#64748B]" data-id="element-6250">
              Currently connected to your WinePik account
            </p>
          </div>

          <div className="space-y-3 md:space-y-4" data-id="element-6251">
            {/* Shopify - Always Active */}
            <Card padding="lg" className="border border-[#E2E8F0]" data-id="element-6252">
              <div className="flex flex-col sm:flex-row items-start justify-between gap-4 sm:gap-6" data-id="element-6253">
                <div className="flex items-start gap-3 md:gap-4 flex-1 w-full" data-id="element-6254">
                  <div className="w-8 h-8 rounded-lg bg-[#95BF47] flex items-center justify-center flex-shrink-0" data-id="element-6255">
                    <span className="text-white text-lg font-bold" data-id="element-6256">S</span>
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-6257">
                    <div className="flex items-center gap-3 mb-1" data-id="element-6258">
                      <h3 className="text-[15px] md:text-[16px] font-semibold text-[#0F172A]" data-id="element-6259">
                        Shopify
                      </h3>
                      <Badge variant="success" data-id="element-6260">Connected</Badge>
                    </div>
                    <p className="text-[13px] md:text-[14px] text-[#64748B]" data-id="element-6261">
                      Core platform connection. Syncs products, customers, and
                      orders.
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-3 flex-shrink-0 w-full sm:w-auto" data-id="element-6262">
                  <button className="text-[13px] md:text-[14px] text-[#0EA5E9] hover:text-[#0284C7] font-medium transition-colors" data-id="element-6263">
                    View Details
                  </button>
                </div>
              </div>
            </Card>

            {/* Klaviyo */}
            <Card padding="lg" className="border border-[#E2E8F0]" data-id="element-6264">
              <div className="flex flex-col sm:flex-row items-start justify-between gap-4 sm:gap-6" data-id="element-6265">
                <div className="flex items-start gap-3 md:gap-4 flex-1 w-full" data-id="element-6266">
                  <div className="w-8 h-8 rounded-lg bg-[#000000] flex items-center justify-center flex-shrink-0" data-id="element-6267">
                    <span className="text-white text-lg font-bold" data-id="element-6268">K</span>
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-6269">
                    <div className="flex items-center gap-3 mb-1" data-id="element-6270">
                      <h3 className="text-[15px] md:text-[16px] font-semibold text-[#0F172A]" data-id="element-6271">
                        Klaviyo
                      </h3>
                      <Badge variant="success" data-id="element-6272">Connected</Badge>
                    </div>
                    <p className="text-[13px] md:text-[14px] text-[#64748B]" data-id="element-6273">
                      Email marketing automation and subscriber communications.
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-3 flex-shrink-0 w-full sm:w-auto" data-id="element-6274">
                  <Button variant="outline" size="sm" iconLeft={<Settings className="w-4 h-4" data-id="element-6276" />} data-id="element-6275">
                    Settings
                  </Button>
                  <button className="text-[13px] md:text-[14px] text-[#64748B] hover:text-[#0F172A] font-medium transition-colors" data-id="element-6277">
                    Disconnect
                  </button>
                </div>
              </div>
            </Card>

            {/* Stripe — Interactive Card (toggles between Not Connected / Connected) */}
            <Card padding="lg" className="border border-[#E2E8F0]" data-id="element-6278">
              <div className="flex flex-col sm:flex-row items-start justify-between gap-4 sm:gap-6" data-id="element-6279">
                <div className="flex items-start gap-3 md:gap-4 flex-1 w-full" data-id="element-6280">
                  <div className="w-8 h-8 rounded-lg bg-[#635BFF] flex items-center justify-center flex-shrink-0" data-id="element-6281">
                    <span className="text-white text-lg font-bold" data-id="element-6282">S</span>
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-6283">
                    <div className="flex items-center gap-3 mb-1" data-id="element-6284">
                      <h3 className="text-[15px] md:text-[16px] font-semibold text-[#0F172A]" data-id="element-6285">
                        Stripe
                      </h3>
                      {isStripeConnected && <Badge variant="success" data-id="element-6286">Connected</Badge>}
                      {isStripeConnected && stripeTestMode && <Badge variant="warning" data-id="element-6287">Test</Badge>}
                    </div>
                    <p className="text-[13px] md:text-[14px] text-[#64748B]" data-id="element-6288">
                      {isStripeConnected ? 'Yarra Valley Wines · acct_1Nx...K2aB' : 'Payment processing for admin-created subscriptions and migrations.'}
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-3 flex-shrink-0 w-full sm:w-auto" data-id="element-6289">
                  {isStripeConnected ? <>
                      {/* Test Mode Toggle */}
                      <label className="flex items-center gap-2 cursor-pointer select-none" data-id="element-6290">
                        <span className="text-[13px] font-medium text-[#64748B]" data-id="element-6291">
                          Test Mode
                        </span>
                        <button role="switch" aria-checked={stripeTestMode} onClick={() => setStripeTestMode(!stripeTestMode)} className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-1 ${stripeTestMode ? 'bg-[#F59E0B] focus:ring-[#F59E0B]/30' : 'bg-[#CBD5E1] focus:ring-[#0EA5E9]/30'}`} data-id="element-6292">
                          <span className={`inline-block h-3.5 w-3.5 transform rounded-full bg-white shadow-sm transition-transform duration-200 ${stripeTestMode ? 'translate-x-[18px]' : 'translate-x-[3px]'}`} data-id="element-6293" />
                        </button>
                      </label>
                      <button className="text-[13px] md:text-[14px] text-[#64748B] hover:text-[#0F172A] font-medium transition-colors" data-id="element-6294">
                        Disconnect
                      </button>
                    </> : <Button variant="primary" size="sm" onClick={openStripeModal} data-id="element-6295">
                      Connect
                    </Button>}
                </div>
              </div>
            </Card>

            {/* Stripe — Connected with Warning (Developer Reference) */}
            <Card padding="none" className="border border-[#E2E8F0]" data-id="element-6296">
              <div className="p-4 md:p-6" data-id="element-6297">
                <div className="flex flex-col sm:flex-row items-start justify-between gap-4 sm:gap-6" data-id="element-6298">
                  <div className="flex items-start gap-3 md:gap-4 flex-1 w-full" data-id="element-6299">
                    <div className="w-8 h-8 rounded-lg bg-[#635BFF] flex items-center justify-center flex-shrink-0" data-id="element-6300">
                      <span className="text-white text-lg font-bold" data-id="element-6301">S</span>
                    </div>
                    <div className="flex-1 min-w-0" data-id="element-6302">
                      <div className="flex items-center gap-3 mb-1" data-id="element-6303">
                        <h3 className="text-[15px] md:text-[16px] font-semibold text-[#0F172A]" data-id="element-6304">
                          Stripe
                        </h3>
                        <Badge variant="warning" data-id="element-6305">Action Required</Badge>
                        {stripeWarningTestMode && <Badge variant="warning" data-id="element-6306">Test</Badge>}
                      </div>
                      <p className="text-[13px] md:text-[14px] text-[#64748B]" data-id="element-6307">
                        Yarra Valley Wines · acct_1Nx...K2aB
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3 flex-shrink-0 w-full sm:w-auto" data-id="element-6308">
                    {/* Test Mode Toggle */}
                    <label className="flex items-center gap-2 cursor-pointer select-none" data-id="element-6309">
                      <span className="text-[13px] font-medium text-[#64748B]" data-id="element-6310">
                        Test Mode
                      </span>
                      <button role="switch" aria-checked={stripeWarningTestMode} onClick={() => setStripeWarningTestMode(!stripeWarningTestMode)} className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-1 ${stripeWarningTestMode ? 'bg-[#F59E0B] focus:ring-[#F59E0B]/30' : 'bg-[#CBD5E1] focus:ring-[#0EA5E9]/30'}`} data-id="element-6311">
                        <span className={`inline-block h-3.5 w-3.5 transform rounded-full bg-white shadow-sm transition-transform duration-200 ${stripeWarningTestMode ? 'translate-x-[18px]' : 'translate-x-[3px]'}`} data-id="element-6312" />
                      </button>
                    </label>
                    <button className="text-[13px] md:text-[14px] text-[#64748B] hover:text-[#0F172A] font-medium transition-colors" data-id="element-6313">
                      Disconnect
                    </button>
                  </div>
                </div>
              </div>
              {/* Warning Bar */}
              <div className="border-t border-[#FDE68A] bg-[#FFFBEB] px-4 md:px-6 py-3 flex items-start gap-2.5 rounded-b-lg" data-id="element-6314">
                <AlertTriangle className="w-4 h-4 text-[#D97706] flex-shrink-0 mt-0.5" data-id="element-6315" />
                <p className="text-[13px] text-[#92400E]" data-id="element-6316">
                  Stripe is not configured as a subscription gateway in Shopify.{' '}
                  <a href="#" className="font-medium text-[#D97706] hover:text-[#B45309] underline transition-colors" onClick={e => e.preventDefault()} data-id="element-6317">
                    Configure in Shopify →
                  </a>
                </p>
              </div>
            </Card>
          </div>
        </div>

        {/* Section 2: Available Integrations */}
        <div data-id="element-6318"></div>

        {/* Section 3: Coming Soon */}
        <div data-id="element-6319">
          <div className="mb-3 md:mb-4" data-id="element-6320">
            <h2 className="text-[18px] md:text-[20px] font-semibold text-[#0F172A] mb-1" data-id="element-6321">
              Coming Soon
            </h2>
            <p className="text-[13px] md:text-[14px] text-[#64748B]" data-id="element-6322">
              Integrations on our roadmap
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4" data-id="element-6323">
            {/* Vinsight */}
            <Card padding="lg" className="border border-[#E2E8F0] opacity-75" data-id="element-6324">
              <div className="flex items-start gap-3 md:gap-4 mb-3 md:mb-4" data-id="element-6325">
                <div className="w-8 h-8 rounded-lg bg-[#94A3B8] flex items-center justify-center flex-shrink-0" data-id="element-6326">
                  <span className="text-white text-lg font-bold" data-id="element-6327">V</span>
                </div>
                <div className="flex-1 min-w-0" data-id="element-6328">
                  <h3 className="text-[15px] md:text-[16px] font-semibold text-[#0F172A] mb-1" data-id="element-6329">
                    Vinsight
                  </h3>
                  <p className="text-[13px] md:text-[14px] text-[#64748B] mb-3" data-id="element-6330">
                    Winery inventory and production management
                  </p>
                  <Badge variant="default" data-id="element-6331">Coming Q3 2026</Badge>
                </div>
              </div>
            </Card>

            {/* InnoVint */}
            <Card padding="lg" className="border border-[#E2E8F0] opacity-75" data-id="element-6332">
              <div className="flex items-start gap-3 md:gap-4 mb-3 md:mb-4" data-id="element-6333">
                <div className="w-8 h-8 rounded-lg bg-[#94A3B8] flex items-center justify-center flex-shrink-0" data-id="element-6334">
                  <span className="text-white text-lg font-bold" data-id="element-6335">I</span>
                </div>
                <div className="flex-1 min-w-0" data-id="element-6336">
                  <h3 className="text-[15px] md:text-[16px] font-semibold text-[#0F172A] mb-1" data-id="element-6337">
                    InnoVint
                  </h3>
                  <p className="text-[13px] md:text-[14px] text-[#64748B] mb-3" data-id="element-6338">
                    Winery production and compliance software
                  </p>
                  <Badge variant="default" data-id="element-6339">Coming Soon</Badge>
                </div>
              </div>
            </Card>

            {/* Tock */}
            <Card padding="lg" className="border border-[#E2E8F0] opacity-75" data-id="element-6340">
              <div className="flex items-start gap-3 md:gap-4 mb-3 md:mb-4" data-id="element-6341">
                <div className="w-8 h-8 rounded-lg bg-[#94A3B8] flex items-center justify-center flex-shrink-0" data-id="element-6342">
                  <span className="text-white text-lg font-bold" data-id="element-6343">T</span>
                </div>
                <div className="flex-1 min-w-0" data-id="element-6344">
                  <h3 className="text-[15px] md:text-[16px] font-semibold text-[#0F172A] mb-1" data-id="element-6345">
                    NowBookIt
                  </h3>
                  <p className="text-[13px] md:text-[14px] text-[#64748B] mb-3" data-id="element-6346">
                    Cellar door reservations and hospitality
                  </p>
                  <Badge variant="default" data-id="element-6347">Coming Soon</Badge>
                </div>
              </div>
            </Card>

            {/* ShipCompliant / Sovos */}
            <Card padding="lg" className="border border-[#E2E8F0] opacity-75" data-id="element-6348">
              <div className="flex items-start gap-3 md:gap-4 mb-3 md:mb-4" data-id="element-6349">
                <div className="w-8 h-8 rounded-lg bg-[#94A3B8] flex items-center justify-center flex-shrink-0" data-id="element-6350">
                  <span className="text-white text-lg font-bold" data-id="element-6351">SC</span>
                </div>
                <div className="flex-1 min-w-0" data-id="element-6352">
                  <h3 className="text-[15px] md:text-[16px] font-semibold text-[#0F172A] mb-1" data-id="element-6353">
                    ShipCompliant / Sovos
                  </h3>
                  <p className="text-[13px] md:text-[14px] text-[#64748B] mb-3" data-id="element-6354">
                    US wine shipping compliance
                  </p>
                  <Badge variant="default" data-id="element-6355">Coming Soon</Badge>
                </div>
              </div>
            </Card>

            {/* VinoShipper */}
            <Card padding="lg" className="border border-[#E2E8F0] opacity-75" data-id="element-6356">
              <div className="flex items-start gap-3 md:gap-4 mb-3 md:mb-4" data-id="element-6357">
                <div className="w-8 h-8 rounded-lg bg-[#94A3B8] flex items-center justify-center flex-shrink-0" data-id="element-6358">
                  <span className="text-white text-lg font-bold" data-id="element-6359">VS</span>
                </div>
                <div className="flex-1 min-w-0" data-id="element-6360">
                  <h3 className="text-[15px] md:text-[16px] font-semibold text-[#0F172A] mb-1" data-id="element-6361">
                    VinoShipper
                  </h3>
                  <p className="text-[13px] md:text-[14px] text-[#64748B] mb-3" data-id="element-6362">
                    US DTC wine shipping and permits
                  </p>
                  <Badge variant="default" data-id="element-6363">Coming Soon</Badge>
                </div>
              </div>
            </Card>
          </div>
        </div>

        {/* Section 4: Recommended Shopify Apps */}
        <div data-id="element-6364">
          <div className="mb-3 md:mb-4" data-id="element-6365">
            <h2 className="text-[18px] md:text-[20px] font-semibold text-[#0F172A] mb-1" data-id="element-6366">
              Recommended Shopify Apps
            </h2>
            <p className="text-[13px] md:text-[14px] text-[#64748B]" data-id="element-6367">
              These apps work great alongside WinePik
            </p>
          </div>

          <div className="bg-[#E0F2FE] border border-[#BAE6FD] rounded-lg p-3 md:p-4 mb-3 md:mb-4 flex items-start gap-3" data-id="element-6368">
            <Info className="w-5 h-5 text-[#0284C7] flex-shrink-0 mt-0.5" data-id="element-6369" />
            <p className="text-[13px] md:text-[14px] text-[#0284C7]" data-id="element-6370">
              These are third-party Shopify apps. Install them directly from
              Shopify - no WinePik setup required.
            </p>
          </div>

          {/* App Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4" data-id="element-6371">
            {/* Shippit */}
            <Card padding="md" className="border border-[#E2E8F0]" data-id="element-6372">
              <div className="flex items-start gap-3 mb-3" data-id="element-6373">
                <div className="w-6 h-6 rounded bg-[#00B67A] flex items-center justify-center flex-shrink-0" data-id="element-6374">
                  <span className="text-white text-sm font-bold" data-id="element-6375">S</span>
                </div>
                <div className="flex-1 min-w-0" data-id="element-6376">
                  <h3 className="text-[13px] md:text-[14px] font-semibold text-[#0F172A] mb-1" data-id="element-6377">
                    Shippit
                  </h3>
                  <p className="text-[12px] md:text-[13px] text-[#64748B]" data-id="element-6378">
                    Multi-carrier shipping for Australia
                  </p>
                </div>
              </div>
              <a href="https://apps.shopify.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-[12px] md:text-[13px] text-[#0EA5E9] hover:text-[#0284C7] font-medium transition-colors" data-id="element-6379">
                View in App Store
                <ExternalLink className="w-3 h-3" data-id="element-6380" />
              </a>
            </Card>

            {/* Starshipit */}
            <Card padding="md" className="border border-[#E2E8F0]" data-id="element-6381">
              <div className="flex items-start gap-3 mb-3" data-id="element-6382">
                <div className="w-6 h-6 rounded bg-[#FF6B35] flex items-center justify-center flex-shrink-0" data-id="element-6383">
                  <span className="text-white text-sm font-bold" data-id="element-6384">C</span>
                </div>
                <div className="flex-1 min-w-0" data-id="element-6385">
                  <h3 className="text-[13px] md:text-[14px] font-semibold text-[#0F172A] mb-1" data-id="element-6386">
                    Corkship
                  </h3>
                  <p className="text-[12px] md:text-[13px] text-[#64748B]" data-id="element-6387">
                    eParcel for Australian wineries
                  </p>
                </div>
              </div>
              <a href="https://apps.shopify.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-[12px] md:text-[13px] text-[#0EA5E9] hover:text-[#0284C7] font-medium transition-colors" data-id="element-6388">
                View in App Store
                <ExternalLink className="w-3 h-3" data-id="element-6389" />
              </a>
            </Card>

            {/* ShipStation */}
            <Card padding="md" className="border border-[#E2E8F0]" data-id="element-6390">
              <div className="flex items-start gap-3 mb-3" data-id="element-6391">
                <div className="w-6 h-6 rounded bg-[#3B5998] flex items-center justify-center flex-shrink-0" data-id="element-6392">
                  <span className="text-white text-sm font-bold" data-id="element-6393">SS</span>
                </div>
                <div className="flex-1 min-w-0" data-id="element-6394">
                  <h3 className="text-[13px] md:text-[14px] font-semibold text-[#0F172A] mb-1" data-id="element-6395">
                    ShipStation
                  </h3>
                  <p className="text-[12px] md:text-[13px] text-[#64748B]" data-id="element-6396">
                    Global multi-carrier shipping
                  </p>
                </div>
              </div>
              <a href="https://apps.shopify.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-[12px] md:text-[13px] text-[#0EA5E9] hover:text-[#0284C7] font-medium transition-colors" data-id="element-6397">
                View in App Store
                <ExternalLink className="w-3 h-3" data-id="element-6398" />
              </a>
            </Card>
          </div>
        </div>
      </div>

      {/* Stripe Connect Modal */}
      {isStripeModalOpen && <>
          {/* Backdrop */}
          <div className="fixed inset-0 bg-[rgba(15,23,42,0.5)] z-[1040] animate-[ocean-fade-in_200ms_ease-in-out]" onClick={closeStripeModal} data-id="element-6399" />

          {/* Modal */}
          <div className="fixed inset-0 flex items-center justify-center z-[1050] p-4" data-id="element-6400">
            <div className="bg-white rounded-xl shadow-xl w-full max-w-[480px] animate-[ocean-scale-in_200ms_ease-in-out]" onClick={e => e.stopPropagation()} data-id="element-6401">
              <div className="p-8" data-id="element-6402">
                {modalStep === 'connect' && <div className="animate-[ocean-fade-in_200ms_ease-in-out]" data-id="element-6403">
                    {/* Stripe Icon */}
                    <div className="flex justify-center mb-6" data-id="element-6404">
                      <div className="w-14 h-14 rounded-2xl bg-[#635BFF] flex items-center justify-center" data-id="element-6405">
                        <span className="text-white text-2xl font-bold" data-id="element-6406">S</span>
                      </div>
                    </div>

                    {/* Heading */}
                    <h2 className="text-[20px] font-semibold text-[#0F172A] text-center mb-2" data-id="element-6407">
                      Connect your Stripe account
                    </h2>

                    {/* Body */}
                    <p className="text-[14px] text-[#64748B] text-center mb-6 leading-relaxed" data-id="element-6408">
                      You'll be redirected to Stripe to authorise WinePik to
                      access your account. This allows WinePik to securely
                      collect payment methods for your subscriptions.
                    </p>

                    {/* Bullet Points */}
                    <div className="space-y-3 mb-8" data-id="element-6409">
                      <div className="flex items-start gap-3" data-id="element-6410">
                        <CheckCircle2 className="w-5 h-5 text-[#10B981] flex-shrink-0 mt-0.5" data-id="element-6411" />
                        <span className="text-[14px] text-[#0F172A]" data-id="element-6412">
                          Securely collect card details for subscriptions
                        </span>
                      </div>
                      <div className="flex items-start gap-3" data-id="element-6413">
                        <CheckCircle2 className="w-5 h-5 text-[#10B981] flex-shrink-0 mt-0.5" data-id="element-6414" />
                        <span className="text-[14px] text-[#0F172A]" data-id="element-6415">
                          Import existing payment methods for migrations
                        </span>
                      </div>
                    </div>

                    {/* Primary CTA */}
                    <button onClick={handleContinueToStripe} className="w-full h-12 bg-[#0EA5E9] text-white text-[14px] font-medium rounded-md hover:bg-[#0284C7] active:bg-[#0369A1] focus:outline-none focus:ring-[3px] focus:ring-[#0EA5E9]/20 transition-all duration-200" data-id="element-6416">
                      Continue to Stripe →
                    </button>

                    {/* Cancel */}
                    <div className="text-center mt-4" data-id="element-6417">
                      <button onClick={closeStripeModal} className="text-[14px] text-[#94A3B8] hover:text-[#64748B] font-medium transition-colors" data-id="element-6418">
                        Cancel
                      </button>
                    </div>
                  </div>}

                {modalStep === 'success' && <div className="animate-[ocean-fade-in_200ms_ease-in-out]" data-id="element-6419">
                    {/* Success Icon */}
                    <div className="flex justify-center mb-6" data-id="element-6420">
                      <div className="w-14 h-14 rounded-full bg-[#D1FAE5] flex items-center justify-center" data-id="element-6421">
                        <CheckCircle2 className="w-8 h-8 text-[#10B981]" data-id="element-6422" />
                      </div>
                    </div>

                    {/* Heading */}
                    <h2 className="text-[20px] font-semibold text-[#0F172A] text-center mb-2" data-id="element-6423">
                      Stripe account connected
                    </h2>

                    {/* Body */}
                    <p className="text-[14px] text-[#64748B] text-center mb-8 leading-relaxed" data-id="element-6424">
                      Yarra Valley Wines (acct_1Nx...K2aB) has been successfully
                      connected to WinePik.
                    </p>

                    {/* Done CTA */}
                    <button onClick={handleDone} className="w-full h-12 bg-[#0EA5E9] text-white text-[14px] font-medium rounded-md hover:bg-[#0284C7] active:bg-[#0369A1] focus:outline-none focus:ring-[3px] focus:ring-[#0EA5E9]/20 transition-all duration-200" data-id="element-6425">
                      Done
                    </button>
                  </div>}
              </div>
            </div>
          </div>
        </>}
    </div>;
}